import actions from './actions';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  isFetching: false,
  successMessage: '',
  errorMessage: '',
  actionType: '',
  status_code: 0,
  data: [],
});

export default function QualificationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_QUALIFICATION_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: 'CREATE_QUALIFICATION_REQUEST',
      });
    case actions.CREATE_QUALIFICATION__SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'CREATE_QUALIFICATION__SUCCESS',
        successMessage: action.successMessage,
      });
    case actions.CREATE_QUALIFICATION__ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'CREATE_QUALIFICATION__ERROR',
        errorMessage: action.error,
      });
    case actions.GET_QUALIFICATION_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: 'GET_QUALIFICATION_REQUEST',
      });
    case actions.GET_QUALIFICATION_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'GET_QUALIFICATION_SUCCESS',
        data: action.data,
      });
    case actions.GET_QUALIFICATION_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'GET_QUALIFICATION_ERROR',
        errorMessage: action.error,
      });
    case actions.UPDATE_QUALIFICATION_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: 'UPDATE_QUALIFICATION_REQUEST',
      });
    case actions.UPDATE_QUALIFICATION_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'UPDATE_QUALIFICATION_SUCCESS',
        successMessage: action.successMessage,
      });
    case actions.UPDATE_QUALIFICATION_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'UPDATE_QUALIFICATION_ERROR',
        errorMessage: action.error,
      });
    case actions.DELETE_QUALIFICATION_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: 'DELETE_QUALIFICATION_REQUEST',
      });
    case actions.DELETE_QUALIFICATION_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'DELETE_QUALIFICATION_SUCCESS',
        successMessage: action.successMessage,
      });
    case actions.DELETE_QUALIFICATION_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'DELETE_QUALIFICATION_ERROR',
        errorMessage: action.error,
      });
    case actions.SORT_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
        actionType: 'SORT_REQUEST',
      });
    case actions.SORT_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'SORT_SUCCESS',
        data: action.data,
      });
    case actions.SORT_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        actionType: 'SORT_ERROR',
        errorMessage: action.error,
        status_code: action.status_code,
      });

    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: '',
        successMessage: '',
        errorMessage: '',
        status_code: 0,
      });
    default:
      return state;
  }
}
